export default "__VITE_ASSET__AR2DFDZI__"